import { GrpcInput } from '../../types/cart'

export function confirmationGRPCInput(
  channelCode: string | null | undefined,
  propertyCode: string,
  providerCode: string | null | undefined
): GrpcInput {
  return {
    channelCode: channelCode || '',
    propertyCode,
    providerCode: providerCode || ''
  }
}
